import React, { useState, useEffect } from 'react'
import TitleBar from '../features/processes/components/TitleBar'
import Menu from '../features/processes/components/Menu'
import ConfigSection from '../features/processes/components/ConfigSection';
import RegistersSection from '../features/processes/components/RegistersSection';
import DashboardSection from '../features/processes/components/DashboardSection';
import { useProcesses } from '../providers/ProcessesContext';
import CubeLoader from '../components/CubeLoader';

function ProcessesContainer(props) {
  const {selectedOption, selectedSubOption, fetchingProcess } = useProcesses();
  // Menú lateral visible por defecto en escritorio; el usuario lo puede
  // ocultar y el contenido de la derecha ocupa el espacio que libera. En
  // pantallas angostas arranca oculto y se muestra como panel flotante
  // (drawer) para no robarle todo el ancho al contenido.
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth < 768);
  const [menuCollapsed, setMenuCollapsed] = useState(() => typeof window !== 'undefined' && window.innerWidth < 768);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const handleChange = (e) => setIsMobile(e.matches);
    if (mq.addEventListener) mq.addEventListener('change', handleChange);
    else mq.addListener(handleChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', handleChange);
      else mq.removeListener(handleChange);
    };
  }, []);

  useEffect(() => {
    // En mobile, al navegar a otra sección el drawer se cierra solo.
    if (isMobile) setMenuCollapsed(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption, selectedSubOption]);

  console.log(selectedOption, selectedSubOption)
  /* const [selectedOption, setSelectedOption] = useState(null);
  const [selectedSubOption, setSelectedSubOption] = useState(null); */
  return (
    <div className='flex flex-col w-full h-screen'>
      <div className='min-h-10 '>
        <TitleBar text={"Procesos"} />
      </div>
      <div className='h-full '>
        {fetchingProcess && (
          <div className='w-full h-full flex items-center justify-center'>
            <CubeLoader />
          </div>)}
        {!fetchingProcess && (
          <div className='w-full h-full flex relative'>
            {isMobile && !menuCollapsed && (
              <div
                className='md:hidden absolute inset-0 bg-black/30 z-30'
                onClick={() => setMenuCollapsed(true)}
              />
            )}
            <section
              className={`flex shrink-0 transition-all duration-200 ${
                menuCollapsed
                  ? 'w-8'
                  : 'absolute inset-y-0 left-0 z-40 w-64 shadow-2xl md:shadow-none md:static md:z-auto md:w-[15%] md:min-w-[220px]'
              }`}
            >
              <Menu collapsed={menuCollapsed} onToggleCollapse={() => setMenuCollapsed((prev) => !prev)} />
            </section>
            <section className='flex-1 min-w-0 flex'>
              {selectedSubOption === "Configuración" && selectedOption !== "Dashboard" && (
                <ConfigSection />
              )}
              {selectedSubOption === "Registros" && selectedOption !== "Dashboard" && (
                <RegistersSection />
              )}
              {selectedOption === "Dashboard" && (
                <DashboardSection />
              )}
            </section>
          </div>
        )}
        
      </div>
      {/* <div className='basis-10'>
        <TitleBar text={"Procesos"} />
      </div>
      <div className='h-full bg-cyan-900'>
        <div className='w-full h-full flex'>
          <section className='w-[15%] flex'>
            <Menu />
          </section>
        </div>
      </div> */}
      
      
    </div>
  )
}

export default ProcessesContainer